import { styled } from '@mui/material'
import { FlexCenter } from 'styles'
import { ReactComponent as FastIcon } from './fast.svg'

const FastWrap = styled(FlexCenter)`
  gap: 2px;
  align-items: center;
  color: rgba(149, 164, 173, 1);
  svg {
    margin-right: 0;
  }
`

const FastWithdrawalFlag = () => {
  return (
    <FastWrap>
      <FastIcon />
      <span>Support fast withdrawal</span>
    </FastWrap>
  )
}

export default FastWithdrawalFlag
